import axios from "axios";

export const SECTION_URL = "/Section";
export const LEVEL_SECTION_URL = "/LevelSection";
export const STUDENT_LEVEL_SECTION_URL = "/StudentLevelSection";

/** Mevcut Okulun Belli Bir Kur Sınıfına Ait Belli Bir Öğrenci Listesini Elde Eder */
export function getStudentAndLevelSections(queryParams) {
  return axios.post(`${STUDENT_LEVEL_SECTION_URL}/GetStudentAndLevelSections`, queryParams);
}

/** Mevcut Okulun Belli Bir Kur Sınıfına Ait Belli Bir Öğrenci Listesini Sayfalama Olmadan Elde Eder */
export function getAllStudentAndLevelSections(queryParams) {
  return axios.post(`${STUDENT_LEVEL_SECTION_URL}/GetAllStudentAndLevelSections`, queryParams);
}

/** Mevcut Okulun Belli Bir Sınıfa Ait Belli Bir Aktif Öğrenci Listesini Elde Eder */
export function getStudents(queryParams) {
  return axios.post(`${STUDENT_LEVEL_SECTION_URL}/GetStudents`, queryParams);
}

/** Mevcut Okulun Aktif Kur Dersi Listesini Elde Eder */
export function getAllLevelCourses() {
  return axios.get(`${LEVEL_SECTION_URL}/GetLevelCourses`);
}

/** Mevcut Okulun Belli Bir Sınıfına Ait Aktif Kur Dersi Listesini Elde Eder */
export function getLevelCourses(grade) {
  return axios.get(`${LEVEL_SECTION_URL}/GetLevelCourses/${grade}`);
}

/** Mevcut Okulun Belli Bir Kur Dersine Ait Aktif Kur Sınıfı Listesini Elde Eder */
export function getLevelSections(courseId) {
  return axios.get(`${LEVEL_SECTION_URL}/GetLevelSections/${courseId}`);
}

/** Mevcut Okulun Belli Bir Kur Sınıfındaki Öğrencilerinin Kayıt Id lerini Elde Eder */
export function getRegistrationInfoIds(sectionId) {
  return axios.get(`${STUDENT_LEVEL_SECTION_URL}/${sectionId}`);
}

/** Belli Bir Öğrenci Listesini Belli Bir Kur Sınıfına Kaydeder */
export function saveStudents(entityId, ids) {
  return axios.post(STUDENT_LEVEL_SECTION_URL, { entityId, ids });
}

/** Belli Bir Öğrenci Listesini İlgili Kur Sınıflarından Çıkarır */
export function removeStudents(ids) {
  return axios.post(`${STUDENT_LEVEL_SECTION_URL}/Remove`, ids);
}